<template>
  <utility :loading="loading">
    <b-col sm="12" class="mt-4 text-center">
      <div class="mb-3">
        <h4>{{ $t('pages.pricing.choose') }}</h4>
        <p
            class="text-muted"
            v-html="$t('pages.pricing.slogan')">
        </p>
      </div>
    </b-col>
    <loader :loading="loading" :class="{'loader' : loading}">
      <pricing-table :pricing="pricing" @choose="choose" :subscribeLoading="subscribeLoading"></pricing-table>
    </loader>
  </utility>
</template>
<script>
/**
 * Pricing component
 */
import SubscriptionService from "../../Services/Api/SubscriptionService";
import Utility from "../Utility/Utility";
import PricingTable from "./PricingTable";
import UserService from "../../Services/Api/UserService";
import Swal from "sweetalert2";

export default {
  components: {PricingTable, Utility},
  page() {
    return {
      title: this.$t('pages.pricing.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  data() {
    return {
      title: this.$t('pages.pricing.title'),
      pricing: [],
      loading: false,
      subscribeLoading: ''
    }
  },
  methods: {
    getPricing() {
      this.loading = true
      SubscriptionService.pricing().then(res => {
        this.pricing = res.data.filter((item) => {
          return item.name !== 'free_plan'
        })
      }).finally(() => {
        this.loading = false
      })
    },
    async choose(data) {
      const userHasPlan = this.$auth.user().subscription && this.$auth.user().subscription?.plan !== 'free_plan'
      const planText = this.$t('common.pricing.' + data.name)
      const confirmButtonText = this.$t(`pages.pricing.${userHasPlan ? 'update' : 'confirm'}`)
      const title = userHasPlan ? this.$t('pages.pricing.change_message', {plan: planText}) : this.$t('pages.pricing.create_message', {plan: planText})

      Swal.fire({
        title,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        showLoaderOnConfirm: true,
        confirmButtonText,
        cancelButtonText: this.$t('pages.pricing.cancel'),
        preConfirm: async () => {

          this.loading = true
          const payload = {
            plan: data.name,
          }

          Swal.disableButtons()

          await UserService.choose({payload}).then((res) => {
            const resData = res.data
            if (resData.redirect_url) {
              Swal.fire({
                title: this.$t('pages.pricing.redirect'),
                timer: 3000,
                timerProgressBar: true,
                showConfirmButton: false,
                allowOutsideClick: false,
                willClose: () => {
                  this.loading = false
                  window.location.href = resData.redirect_url
                }
              })
            } else {
              if (resData.message) {
                Swal.fire(this.$t(`pages.pricing.${resData.message}`), '', "info")
              }
            }
          }).catch((e) => {

            e.status === 409
                ? Swal.fire(this.$t('pages.pricing.over_error_title'), this.$t('pages.pricing.over_error_text'), "error")
                : Swal.showValidationMessage(this.$t('pages.pricing.plan_error'))

          }).finally(() => {
            this.loading = false
          })
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
          this.$auth.fetch()
          this.$router.push({name: 'settings'})
        }
      })
    }
  },
  created() {
    this.getPricing()
  }
}
</script>
<style>
.loader {
  margin-top: 3%;
}
</style>